import { ReactNode } from "react";

import { Spinner } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { AttendingStatus, InvitationStatus } from "@/graphql";
import { Attendee, FullMeeting, UpcomingMeeting } from "@/types/meetings";

import { AttendeeRowView } from "./AttendeeRowView";

type Meeting = FullMeeting | UpcomingMeeting;

interface AttendeeListProps {
  loading?: boolean;
  attendees: Attendee[];
  organizer?: Meeting["customer"];
  total?: number; // total number of attendees exclude the Organizer
  onLoadMore?: () => void;
  mode: "view" | "view-with-status" | "edit";
  onClick?: (attendee: Attendee) => void;
  error?: ReactNode;
  limit?: number;
}

export function AttendeeList({
  loading = false,
  attendees,
  organizer,
  total = 0,
  mode = "view-with-status",
  error,
  onClick,
  limit = 0,
}: AttendeeListProps) {
  const remainNum = limit > 0 ? total - limit : 0;

  return (
    <Box>
      {organizer ? (
        <AttendeeRowView
          attendee={
            {
              id: "-1",
              user: organizer,
              email: organizer?.email,
              status: InvitationStatus.Invited,
              attendingStatus: AttendingStatus.Attending,
            } as unknown as Attendee
          }
          isOrganizer={true}
          mode="view-with-status"
        />
      ) : null}
      {attendees.slice(0, limit > 0 ? limit : 1000).map((attendee) => (
        <AttendeeRowView
          key={`${attendee?.email}`}
          attendee={attendee}
          isOrganizer={false}
          mode={mode}
          onClick={onClick}
        />
      ))}
      {remainNum > 0 ? (
        <Box py={2}>
          +{remainNum} <span>more</span>
        </Box>
      ) : null}
      {error ? <Box mt={1}>{error}</Box> : null}
      {loading ? (
        <Flex
          justifyContent="center"
          p={2}
          css={
            {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              opacity: 0.5,
              width: "100%",
              height: "100%",
              background: "#fff",
            } as const
          }
        >
          <Spinner intent="primary" />
        </Flex>
      ) : null}
    </Box>
  );
}
